
<div class="container register-container">
  <div class="row row-1">
    <div class="col-sm-7 col-1">
      <h2 class="overview-header register-header">Register</h2>
    </div>
    <div class="col-sm-5 col-2">
    </div>
  </div>

  <div class="card" style="">
    <div class="card-header bp-card-header">
      <!-- Steps form -->
      <div class="card">
        <div class="card-body mb-4">
          <!-- Stepper -->
          <div class="steps-form">
            <div class="steps-row setup-panel">
              <div class="steps-step step-1">
                <a href="#step-9" type="button" class="btn btn-indigo btn-circle">1</a>
                <p class="bp-text">Find Account</p>
              </div>
              <div class="steps-step step-2">
                <a href="#step-10" type="button" class="btn btn-indigo btn-circle" disabled="disabled">2</a>
                <p class="bp-text">About You</p>
              </div>
              <div class="steps-step step-3">
                <a href="#step-11" type="button" class="btn btn-default btn-circle" disabled="disabled">3</a>
                <p class="bp-text">Set Password</p>
              </div>
            </div>
          </div>

          <form role="form" action="" method="post">

            <!-- First Step -->
            <div class="row setup-content" id="step-9">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Second Step -->
            <div class="row setup-content" id="step-10">
              <div class="col-md-12">
              </div>
            </div>

            <!-- Third Step -->
            <div class="row setup-content" id="step-11">
              <div class="col-md-12">
              </div>
            </div>

          </form>

        </div>
      </div>
      <!-- Steps form -->
    </div>
    <div class="card-body" style="margin-bottom: 3%;">
      <div class="row register-row bp-text bp-small-text" style="margin-top: 1.5%;margin-bottom: .3%;">
        <p class="color: #777;">Please verify or update the information below .</p>
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="customerAlreadyExists">
        <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
        <span>You've already created an account. Please log in.</span>
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="emailsDontMatch">
        <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
        <span>Emails do not match.</span>
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="accountNotFound">
        <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
        <span>An error has occurred. Your account can not be found.</span>
      </div>
      <div class="row register-row">
        <div class="col-sm-6">
          <form #registrationAboutYouForm="ngForm">
            <div class="form-group bill-info-form-group">

              <label for="txtUpdateFirstName" class="bp-text login-label bp-small-text">First Name</label>
              <input #txtUpdateFirstName="ngModel" [(ngModel)]="customer.firstName" name="txtUpdateFirstName" required type="text" class="form-control form-input-6" id="txtUpdateFirstName">
              <div [hidden]="txtUpdateFirstName.valid || txtUpdateFirstName.pristine" class="alert alert-danger register-alert-6">Please enter First Name</div>

              <label for="txtUpdateLastName" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Last Name</label>
              <input #txtUpdateLastName="ngModel" [(ngModel)]="customer.lastName" name="txtUpdateLastName" required type="text" class="form-control form-input-6" id="txtUpdateLastName">
              <div [hidden]="txtUpdateLastName.valid || txtUpdateLastName.pristine" class="alert alert-danger register-alert-6">Please enter Last Name</div>

              <label for="txtUpdateEmail" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Email</label>
              <input #txtUpdateEmail="ngModel" [(ngModel)]="customer.email" name="txtUpdateEmail" required type="text" class="form-control form-input-6" id="txtUpdateEmail">
              <div [hidden]="txtUpdateEmail.valid || txtUpdateEmail.pristine" class="alert alert-danger register-alert-6">Please enter Email</div>

              <label for="txtRetypeEmail" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Retype Email</label>
              <input #txtRetypeEmail="ngModel" [(ngModel)]="confirmEmail" name="txtRetypeEmail" required type="text" class="form-control form-input-6" id="txtRetypeEmail">
              <div [hidden]="txtRetypeEmail.valid || txtRetypeEmail.pristine" class="alert alert-danger register-alert-6">Please retype email.</div>
            </div>

            <div class="form-group">
              <button style="width: 23%;" type="submit" [disabled]="!registrationAboutYouForm.form.valid" class="btn btn-primary bp-text" (click)="onAboutYouContinueClick()">CONTINUE</button>
              <span><a class="bp-link-blue" (click)="onBack()">BACK</a></span>
              <span><a class="bp-link-blue" (click)="onCancel()">CANCEL</a></span>
            </div>
          </form>
        </div>
      </div>
      <footer class="blockquote-footer water-usage-footer"></footer>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/about-you/about-you.component.html